import React from "react";
import Img from "react-image";
import _ from "lodash";
import { connect } from "react-redux";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import { TimePickerCustom } from "../../../../../../../src/components"
import moment from "moment";
import {
  postPetitcoinSimple,
  updatePetitCoinEvent,
  DeletePetitCoinEvent,
} from "../les-tabs-ducks/Petitcoin.ducks";
import Classnames from "classnames";

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
moment.locale("fr");
function notEmpty(value) {
  return !_.isEmpty(value);
}
class Petitcoin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      etatSupport: "",
      etatQuantity: "",
      etatAspect: "",
      readySubmit: false,
      initialized: false,
      isOpen: true,
      timePetitcoin: moment(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleStyle = this.handleStyle.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      !_.isEmpty(this.props.petitcoinData)
    ) {
      let petitcoinData = this.props.petitcoinData;
      let kidItem = this.props.kidItem;
      this.setState({
        timePetitcoin: moment(petitcoinData.dateTime),
        etatAspect: petitcoinData.aspect,
        etatQuantity: petitcoinData.type,
        etatSupport: petitcoinData.support,
        initialized: true,
      });
    }
  }
  toggle() {
    this.props.toggle();
    this.setState({
      readySubmit: false,
      etatSupport: "",
      etatQuantity: "",
      etatAspect: "",
    });
  }

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState({ [name]: event.target.id }, () => {
        let readySubmit = this.props.readySubmit;
        let tabSubmit;
        notEmpty(this.state.etatSupport) &&
        notEmpty(this.state.etatQuantity) &&
        notEmpty(this.state.etatAspect)
          ? (tabSubmit = true)
          : (tabSubmit = false);
        if (tabSubmit && readySubmit === false) {
          this.props.handleReadySubmit();
        } else if (tabSubmit === false && readySubmit) {
          this.props.handleReadySubmit();
        }
      });
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timePetitcoin: date }, () => {
        let readySubmit = this.props.readySubmit;
        let tabSubmit;
        notEmpty(this.state.timePetitcoin)
        ? (tabSubmit = true)
        : (tabSubmit = false);
        if (tabSubmit && readySubmit === false) {
          this.props.handleReadySubmit();
        } else if (tabSubmit === false && readySubmit) {
          this.props.handleReadySubmit();
        }
      });
    }
  };

  handleSubmit(event) {
    event.preventDefault();
    if (
      this.props.isUpdate &&
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.etatSupport) &&
      notEmpty(this.state.etatQuantity) &&
      notEmpty(this.state.etatAspect)
    ) {
      let data = {
        aspect: this.state.etatAspect,
        dateTime: moment(this.state.timePetitcoin).format(),
        type: this.state.etatQuantity,
        support: this.state.etatSupport,
      };
      this.props.updatePetitCoinEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data
      );
    } else {
      let data = {
        aspect: this.state.etatAspect,
        dateTime: moment(this.state.timePetitcoin).format(),
        type: this.state.etatQuantity,
        support: this.state.etatSupport,
      };
      let readySubmit = this.props.readySubmit;
      let tabSubmit;
      notEmpty(this.state.etatSupport) &&
      notEmpty(this.state.etatQuantity) &&
      notEmpty(this.state.etatAspect)
        ? (tabSubmit = true)
        : (tabSubmit = false);
      if (tabSubmit) {
        this.props.postPetitcoinSimple(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        this.props.handleSubmit();
      }
    }
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.DeletePetitCoinEvent(
      localStorage.getItem("token"),
      this.props.idEvent
    );
  }
  handleStyle() {
    return this.props.readySubmit
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }

  render() {
    return (
      <div
        className="tab-pane  show active"
        id="petitcoin-pane"
        role="tabpanel"
        aria-labelledby="petitcoin-tab"
      >
        <div className="content">
        <h2 className="mb-2">À quelle heure ?</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timePetitcoin} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>

          <h2 style={{ marginTop: "15px" }}>Support utilisé</h2>
          <div className="row mx-n2 mb-4 d-flex align-items-center justify-content-center choices-objets objet-sante">
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="COUCHE"
                value={this.state.etatSupport}
                name="etatSupport"
              />
              <label
                htmlFor="COUCHE"
                className={Classnames("couches", {
                  active: this.state.etatSupport === "COUCHE",
                })}
              >
                <span>Couche</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="POT"
                value={this.state.etatSupport}
                name="etatSupport"
              />
              <label
                htmlFor="POT"
                className={Classnames("pot", {
                  active: this.state.etatSupport === "POT",
                })}
              >
                <span>Pot</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="CUVETTE"
                value={this.state.etatSupport}
                name="etatSupport"
              />
              <label
                htmlFor="CUVETTE"
                className={Classnames("cuvette", {
                  active: this.state.etatSupport === "CUVETTE",
                })}
              >
                <span>Cuvette</span>
              </label>
            </div>
          </div>
          <div className="etat-sante">
            <h2>Quantité</h2>
            <div className="row mx-n2 justify-content-center">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="PETITE_COMMISSION"
                  value={this.state.etatQuantity}
                  name="etatQuantity"
                />
                <label
                  htmlFor="PETITE_COMMISSION"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatQuantity === "PETITE_COMMISSION",
                  })}
                >
                  Petite commission
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="GROSSE_COMMISSION"
                  value={this.state.etatQuantity}
                  name="etatQuantity"
                />
                <label
                  htmlFor="GROSSE_COMMISSION"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatQuantity === "GROSSE_COMMISSION",
                  })}
                >
                  Grosse commission
                </label>
              </div>
            </div>
            <h2 className="mt-4">Aspect</h2>
            <div className="row mx-n2 justify-content-center">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="NORMAL"
                  value={this.state.etatAspect}
                  name="etatAspect"
                />
                <label
                  htmlFor="NORMAL"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatAspect === "NORMAL",
                  })}
                >
                  Normal
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="ANORMAL"
                  value={this.state.etatAspect}
                  name="etatAspect"
                />
                <label
                  htmlFor="ANORMAL"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatAspect === "ANORMAL",
                  })}
                >
                  Anormal
                </label>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              {this.props.onlyView ? (
                ""
              ) : (
                <button
                  type="submit"
                  className="btn-gradient btn-valid"
                  onClick={(event) =>
                    this.handleSubmit(event, this.state.presentIds)
                  }
                  style={this.handleStyle()}
                >
                  <IconCheckWhite /> Valider
                </button>
              )}
              {this.props.isUpdate ? (
                <button
                  onClick={this.handleEventDelete}
                  className="btn-supprimer"
                >
                  Supprimer
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  postPetitcoinSimple,
  updatePetitCoinEvent,
  DeletePetitCoinEvent,
})(Petitcoin);
